import { AxiosProgressEvent } from 'axios';

import { DOWNLOAD, FILE_PROCESSING, PUBLIC, UPLOAD } from 'Config/Paths';
import { SignedDownloadRequest, SignedDownloadResponse, SignedUploadRequest, SignedUploadResponse } from 'Models/Files';
import { ResponseModel } from 'Models/ResponseModel';
import { documentUpload, publicRestApiGet } from 'PublicRestApiConnector';

import { DocumentApi } from './DocumentApi';

export class AWSPublicDocumentApi implements DocumentApi {
    uploadDocument(url: string, fields: { string: string }, file: File, onUploadProgress: (progressEvent: AxiosProgressEvent) => void): Promise<any> {
        return documentUpload(url, fields, file, onUploadProgress);
    }

    downloadText(filePath: string): Promise<Blob> {
        return Promise.reject(new Error('This has not yet been implemented for third-party users.'));
    }

    // Get an S3 presigned POST (pointed at a CloudFront Signed URL) in order to create or update a file in an S3 bucket behind CloudFront.
    getSignedUpload(file_name: string, file_id?: string): Promise<ResponseModel<SignedUploadResponse>> {
        const request: SignedUploadRequest = {
            file_name: file_name,
        };
        if (file_id) {
            request.file_id = file_id;
        }
        return publicRestApiGet(`/${PUBLIC}/${FILE_PROCESSING}/${UPLOAD}`, request);
    }

    getSignedDownload(file_id: string): Promise<ResponseModel<SignedDownloadResponse>> {
        const request: SignedDownloadRequest = {
            file_id: file_id,
        };
        return publicRestApiGet(`/${PUBLIC}/${FILE_PROCESSING}/${DOWNLOAD}`, request);
    }
}
